// extracted by mini-css-extract-plugin
export default {"container":"_not-found_container__pmv6J"};